import React from 'react';

type Props = {
	division: string;
	investmentCopy: string;
	insuranceCopy: string;
	timeOffCopy: string;
	snacksCopy: string;
	careCopy?: string;
	parentalCopy?: string;
	noCaption?: boolean;
};

const Benefits = ({ division, investmentCopy, insuranceCopy, timeOffCopy, snacksCopy, careCopy, parentalCopy, noCaption }: Props) => (
	<div id="benefits">
		<div className="heading">
			<p>Not Your Typical 9 to 5</p>
			<h3>Love where you work.</h3>
			{!noCaption && <p className="caption-one">*These benefits and perks are only applicable to PeopleConnect {division} employees.</p>}
		</div>
		<ul className="benefits-list">
			<li className="benefit-item">
				<h5>Health Insurance</h5>
				<p>{insuranceCopy}</p>
			</li>

			<li className="benefit-item">
				<h5>Long & Short Term Disability</h5>
				<p>The company pays 100% of your Long Term and Short Term Disability. Voluntary options are available for additional coverage for spouses, and children.</p>
			</li>

			<li className="benefit-item">
				<h5>Life & AD&D</h5>
				<p>
					The company pays two times your annual base salary up to $250(k) for your Life and AD&D (Accidental Death and Dismemberment). Voluntary options are available for additional
					coverage.
				</p>
			</li>

			{careCopy && (
				<li className="benefit-item">
					<h5>Child/Elder Care Subsidies</h5>
					<p>{careCopy}</p>
				</li>
			)}

			<li className="benefit-item">
				<h5>401K</h5>
				<p>{investmentCopy}</p>
			</li>

			<li className="benefit-item">
				<h5>Paid time off</h5>
				<p>{timeOffCopy}</p>
			</li>

			{parentalCopy && (
				<li className="benefit-item">
					<h5>Parental Paid Leave</h5>
					<p>{parentalCopy}</p>
				</li>
			)}

			<li className="benefit-item">
				<h5>Snacks and Drinks</h5>
				<p>{snacksCopy}</p>
			</li>

			<li className="benefit-item">
				<h5>Company events & Team Building</h5>
				<p>Get to know your co-workers and enjoy complimentary food and drinks at one of our fun team-building company events!</p>
			</li>
		</ul>
	</div>
);

export default Benefits;
